import { createStore, applyMiddleware } from 'redux';

import { appEpics } from './epics';
import { epicMiddleware } from './epicMiddleware';
import { reduce } from './reducerManager';

const store = createStore(reduce, applyMiddleware(epicMiddleware));
epicMiddleware.run(appEpics);

if (process.env.NODE_ENV === 'development') {
   window.appStore = store;
}

export { store };
